import computed from './attrs/computed'
import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import props from './attrs/props'

export default {
    name: 'Wallet',
    computed,
    created,
    data,
    methods,
    props
}
